import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { getCardImageByProductType } from '~/constants/cardImages';

import { isMobile } from '~/utils';

import nls from './nls/CardDetails';
import { createTranslator } from '~/lib/nls-helper';

export const isButtonVisible = (ismobile) => !isMobile(ismobile);

export const NLS = createTranslator(nls);

export const getImageUrl = (productType) => `images/${getCardImageByProductType(productType)}`;

export const formatAddress = (addressObj) => {
  let addressStr = '';

  if (isEmpty(addressObj))
    return addressStr;

  const streetAddress = get(addressObj, 'streetAddress');
  const neighborhood = get(addressObj, 'neighborhood');
  const city = get(addressObj, 'city');
  const state = get(addressObj, 'state');
  const postalCode = get(addressObj, 'postalCode');

  addressStr = `${streetAddress}, ${neighborhood}, ${city}, ${state}, ${postalCode}`;

  return addressStr;
};

export const getIntrinsicSizeByCardType = (productType) => {
  switch (productType) {
    case 'gold':
    case 'platinum':
    case '2now':
    case 'one':
      return '150x228';
    case 'air':
      return '150x237';
    case 'pwe':
    case 'zero':
      return '200x126';
    case 'viva':
    case 'vivaPlus':
      return '150x225';
    default:
      return '200x126';
  }
};

export const isImageHorizontal = (intrinsicSize) => {
  if (isEmpty(intrinsicSize)) {
    return true;
  } else {
    let [intrinsicWidth, intrinsicHeight] = intrinsicSize.split('x');
    return (intrinsicWidth >= intrinsicHeight);
  }
};
